import { Facebook, Twitter, Instagram, Linkedin, Youtube } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import {AutoTranslate} from "@/lib/autoTranslate.tsx";

export function Footer() {
  const transText = useTranslation().t('autoTranslate', { returnObjects: true });
  const { i18n } = useTranslation();


  return (
    <footer className="bg-white dark:bg-gray-900 border-t border-border py-8 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Social Icons */}
          <div className="space-y-4">
            <div className="flex flex-wrap gap-4">
              <a href="https://www.facebook.com/profile.php?id=61557125345580" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Visit our Facebook page">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="https://x.com/_findservices" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Follow us on Twitter">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="https://instagram.com/find.services" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Follow us on Instagram">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="https://www.linkedin.com/company/find-services/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Connect with us on LinkedIn">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href="https://tiktok.com/@_findservices" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Follow us on TikTok">
                <svg className="h-5 w-5 fill-current" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                </svg>
              </a>
              <a href="https://www.youtube.com/@find.services" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Subscribe to our YouTube channel">
                <Youtube className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="font-semibold text-foreground">{AutoTranslate(`Quick Links`)}</h3>
            <div className="space-y-2">
              <a href="/pricing" className="block text-sm text-muted-foreground hover:text-primary transition-colors">
                {useTranslation().t('landing.pricing')}
              </a>
              <a href="https://wefindservices.org/jobs" target="_blank" rel="noopener noreferrer" className="block text-sm text-muted-foreground hover:text-primary transition-colors">
                {AutoTranslate(`Remote Jobs`)}
              </a>
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button variant="ghost" className="h-auto p-0 font-normal text-sm text-muted-foreground hover:text-primary transition-colors justify-start">
                    {AutoTranslate(`Connect with job seekers who get it`)}
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="start" className="bg-background border-border">
                  <DropdownMenuItem asChild>
                    <a href="https://chat.whatsapp.com/BZ9hirPzG9m3mhlPTeldWc" target="_blank" rel="noopener noreferrer" className="w-full">
                      WhatsApp Community
                    </a>
                  </DropdownMenuItem>
                  <DropdownMenuItem asChild>
                    <a href="https://t.me/findservices_com" target="_blank" rel="noopener noreferrer" className="w-full">
                      Telegram Community
                    </a>
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
              <a href="mailto:info@wefindservices.org" className="block text-sm text-muted-foreground hover:text-primary transition-colors">
                {AutoTranslate(`Contact Us`)}
              </a>
            </div>
          </div>

          {/* Legal */}
          <div className="space-y-4">
            <h3 className="font-semibold text-foreground">{AutoTranslate(`Legal`)}</h3>
            <div className="space-y-2">
              <a href="/privacy" className="block text-sm text-muted-foreground hover:text-primary transition-colors">
                {AutoTranslate(`Privacy`)}
              </a>
              <a href="/terms" className="block text-sm text-muted-foreground hover:text-primary transition-colors">
                {AutoTranslate(`Terms`)}
              </a>
            </div>
          </div>

          {/* Copyright */}
          <div className="space-y-4">
            <div className="text-sm text-muted-foreground">
              © {AutoTranslate(`2026 Resume Builder All rights reserved.`)}
            </div>
            <div className="text-sm">
              {AutoTranslate(`By`)} <a
                href="https://wefindservices.org"
                className="relative inline-block text-primary"
                style={{
                  background: 'linear-gradient(45deg, #ff6b9d, #c44fd1, #6b73ff, #9b59b6)',
                  backgroundSize: '400% 400%',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  animation: 'gradient-beam 3s ease infinite'
                }}
              >
                FIND
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}